import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const prologsConfig: TSPConfig = {
  key: 'prologs',
  name: 'Prologs',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>
        Contact your Prologs representative to obtain your Client ID and Client
        Secret credentials.
      </li>
      <li>Input the provided Client ID and Client Secret below.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Client ID', name: 'database', type: 'text', required: true },
        {
          label: 'Client Secret',
          name: 'authorizationcode',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default prologsConfig;
